import {environment} from '../environments/environment';

export function locationHref(url: string) {
  const path = window.location.pathname.replace(/\/ui\/.*/, url);
  window.location.href = `${environment.urlPrefix}${path}`;
}
